import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { APP_ENVIRONMENT } from '@core/tokens/environment.token';

/**
 * Prefixes relative API paths with environment.apiBaseUrl.
 * Absolute URLs (http/https) and static assets (i18n, assets) are left unchanged.
 */
export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const { apiBaseUrl } = inject(APP_ENVIRONMENT);

  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  // Local static files (ngx-translate JSON, public assets) must not hit the API host.
  if (
    req.url.startsWith('/i18n/') ||
    req.url.startsWith('i18n/') ||
    req.url.startsWith('/assets/') ||
    req.url.startsWith('assets/')
  ) {
    return next(req);
  }

  const base = apiBaseUrl.endsWith('/') ? apiBaseUrl.slice(0, -1) : apiBaseUrl;
  const path = req.url.startsWith('/') ? req.url : `/${req.url}`;

  return next(req.clone({ url: `${base}${path}` }));
};
